import type {StyleRuleObject} from "../../../../../stem-core/ui/Style";
import {UI} from "../../../../../stem-core/ui/UIBase";

import {BasePanelPage, BasePanelPageStyle} from "../../../PanelPage";
import {styleRule, styleRuleInherit} from "../../../../../stem-core/decorators/Style";
import {isSmallScreen} from "../../../../UtilsLib";
import {merchantStyleRule} from "../../../Security";
import {iFrameState} from "../../../../services/IFrameState";
import {registerStyle} from "../../../../../stem-core/ui/style/Theme";
import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {DiscountCodeInput} from "./components/DiscountCodeInput";
import {Messages} from "../../../../Messages";
import {SubscriptionFlowType} from "../../../flows/steps/SubscriptionPlanFlowStep.js";
import {iFrameUserDataService} from "../../../../services/IFrameUserDataService";
import {PanelText} from "../../../panel-elements/PanelText.jsx";
import {Flow} from "../../../flows/Flow.js";
import {PanelImage} from "../../../panel-elements/PanelImage.jsx";
import {SubscriptionCardsList} from "./components/SubscriptionCardsList.jsx";
import {autoredraw} from "../../../../../stem-core/decorators/AutoRedraw";

class SubscriptionPlanPanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    content: StyleRuleObject = {
        width: null,
        textAlign: "center",
    }

    @styleRule
    discountCodeInput = {
        marginBottom: 24,
    };

    messageObject = {
        color: this.themeProps.TEXT_SECONDARY_COLOR,
        textAlign: "center",
        marginBottom: () => (isSmallScreen() ? 18 : 24),
        width: "100%",
        ":last-child": {
            marginBottom: 0,
        },
    };

    @styleRule
    message = {
        ...this.messageObject,
        fontSize: this.themeProps.FONT_SIZE_LARGE,
    };

    @merchantStyleRule
    panelTextStyle = {
        ...iFrameState.textStyle,
    };

    @merchantStyleRule
    panelFooterSeparatorStyle = {
        marginLeft: "auto",
        marginRight: "auto",
        ...iFrameState.footerSeparatorStyle,
    };

    @merchantStyleRule
    panelFooterTextStyle = {
        marginLeft: "auto",
        marginRight: "auto",
        ...iFrameState.footerTextStyle,
    };

    @styleRule
    subscriptionText = {
        margin: "0px auto",
        maxWidth: 700, // TODO @panelapp This shouldn't be hardcoded
        display: "flex",
        flexDirection: isSmallScreen() ? "column" : "row",
        justifyContent: "center",
        alignItems: "flex-start"
    }

    @styleRule
    subscribeImageLogo = {
        width: 150,
        marginTop: 0
    }
}

@autoredraw(iFrameState)
@registerStyle(SubscriptionPlanPanelStyle)
export class SubscriptionPlanPanel extends BasePanelPage {
    renderSubscriptionText() {
        const {styleSheet} = this;
        const panelText = iFrameState.iframeParams.text; // TODO @cleanup shit is also here
        const {subscribeImageLogo} = iFrameState.iframeParams;
        const currentSubscription = iFrameUserDataService.getActiveSubscription();
        const {subscriptionFlowType} = Flow.subscriptionPlan;

        if (subscriptionFlowType === SubscriptionFlowType.EDIT_SUBSCRIPTION) {
            return <div className={styleSheet.message + styleSheet.panelTextStyle}>
                {Messages.currentSubscriptionPlan(currentSubscription.coverage.name, currentSubscription.billingPlan.getCycleDuration(true))}
            </div>
        }

        return <div className={styleSheet.subscriptionText}>
            {subscribeImageLogo && <PanelImage src={subscribeImageLogo} className={styleSheet.subscribeImageLogo}/>}
            {panelText && <PanelText className={styleSheet.panelTextStyle}>{panelText}</PanelText>}
        </div>;
    }

    render() {
        const {styleSheet} = this;
        const merchant = iFrameMerchantService.getMerchant();
        const {footerText, hideDiscountCodeInput} = iFrameState.iframeParams;

        return [
            this.renderSubscriptionText(),
            <SubscriptionCardsList style={{marginBottom: 24}}/>,

            !hideDiscountCodeInput && merchant.hasSubscriptionDiscountCodeEnabled() && <DiscountCodeInput
                className={styleSheet.discountCodeInput}
                initialValue={Flow.subscriptionPlan.discountCode || ""}
                discountApplied={this.isDiscountApplied()}
                onCodeInput={code => this.checkDiscountCode(code)}
            />,

            <div className={styleSheet.panelFooterSeparatorStyle}/>,

            footerText && <PanelText className={styleSheet.panelFooterTextStyle}>{footerText}</PanelText>,

            Flow.subscriptionPlan.renderBackButton(),
        ]
    }

    isDiscountApplied() {
        return !!Flow.subscriptionPlan.discountCode;
    }

    async checkDiscountCode(discountCode: string) {
        Flow.subscriptionPlan.update({discountCode});
        await Flow.subscriptionPlan.fetchPrices(Flow.address.selectedValue);
    }

    async onMount() {
        super.onMount();

        this.attachListener(Flow.subscriptionPlan, () => this.redraw());
    }
}
